import { generateApiRoute } from '@klp/core/api/helpers';
import { getDefaultLanguage } from '@klp/layout/Sidebar/config';

import type { ISakStatus } from './classes/SakStatus';

export const sakApiName = getDefaultLanguage() === 'sv' ? 'dedusak' : 'sak';

export const sakApiRoutes = {
    sak: () => generateApiRoute([sakApiName]),
    sakById: (sakId: string) => generateApiRoute([sakApiName, sakId]),
    sakMelding: () => generateApiRoute([sakApiName, 'melding']),
    sakStatus: (sakId?: string, status?: keyof ISakStatus) =>
        generateApiRoute([sakApiName, sakId, 'state', status]),
    categoryItems: () => generateApiRoute([sakApiName, 'category', 'items']),
    categoryItemsByType: () =>
        generateApiRoute([sakApiName, 'category', 'items', 'type']),
    statusCount: () => generateApiRoute([sakApiName, 'status', 'count']),
    statusItems: () => generateApiRoute([sakApiName, 'status', 'items']),
    sakMeldingAttachment: (
        meldingId?: string,
        attachmentId?: string | number,
    ) =>
        generateApiRoute([
            sakApiName,
            'melding',
            meldingId,
            'vedlegg',
            attachmentId,
            'preview',
        ]),
    sakForsidefeed: (kundenummer: string) =>
        generateApiRoute([sakApiName, kundenummer, 'forsidefeed']),
    nySakConfig: () => generateApiRoute([sakApiName, 'nysak', 'config']),
};

// Dalux-oppsettet finnes bare i Saks API (SuperOffice), ikke i Dedu-API-et.
export const supportsNySakConfig = sakApiName === 'sak';
